import { LineItem } from 'shared/types/cart/LineItem';
import { Availability } from 'shared/types/product/InventoryQuery';
import { isBetweenInputAndInitialDate, isFutureDate } from '@/components/customercenter-ui/utils/fedexUtils';
import { AVAILABILITY_VALUE_BACKORDERED } from '@/constants/constant';

export const mapLineItemsToAvailability = (lineItems?: LineItem[]): Availability[] => {
  if (!lineItems?.length) {
    return [];
  }

  return lineItems.map((lineItem) => {
    const availabilityData = lineItem?.availabilityData ?? {};
    return {
      ...availabilityData,
      sku: availabilityData?.sku ?? lineItem?.variant?.sku,
    };
  });
};

export const hasCompleteAvailabilityData = (lineItems?: LineItem[]): boolean => {
  if (!lineItems?.length) {
    return false;
  }

  return lineItems.every((lineItem) => Boolean(lineItem?.availabilityData));
};

export const getShippingBackorderDateFromAvailability = (result?: Availability[]): string => {
  if (
    !result?.length ||
    !result.every(
      (availability) =>
        availability?.value === AVAILABILITY_VALUE_BACKORDERED &&
        isFutureDate(availability?.backOrderDateWithYear ?? '') &&
        availability?.stockValue === 0,
    )
  ) {
    return '';
  }

  if (
    result.length === 1 &&
    result[0]?.value === AVAILABILITY_VALUE_BACKORDERED &&
    isFutureDate(result[0]?.backOrderDateWithYear ?? '')
  ) {
    return result[0]?.backOrderDateWithYear ?? '';
  }

  let backOrderDate = '';
  result.forEach((availability) => {
    if (availability?.value !== AVAILABILITY_VALUE_BACKORDERED) {
      return;
    }
    if (!backOrderDate && isFutureDate(availability?.backOrderDateWithYear ?? '')) {
      backOrderDate = availability?.backOrderDateWithYear ?? '';
    } else if (
      backOrderDate &&
      isBetweenInputAndInitialDate(availability?.backOrderDateWithYear ?? '', backOrderDate)
    ) {
      backOrderDate = availability?.backOrderDateWithYear ?? '';
    }
  });

  return backOrderDate;
};
